import { render, staticRenderFns } from "./AddChannelSidebar.vue?vue&type=template&id=44d83b64"
import script from "./AddChannelSidebar.vue?vue&type=script&lang=js"
export * from "./AddChannelSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports